export default function DirectAnswerBlock() {
  return <section id="direct-answer-block" className="bg-card-foreground text-primary-foreground py-12 md:py-16">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        <p className="text-lg md:text-xl leading-relaxed font-medium">
          An OEM nameplate supplier produces the identification an equipment manufacturer applies to the products it builds — equipment nameplates, data plates with ratings and serials, and direct part marking — on a recurring basis to a consistent specification. Evermark Industrial Solutions runs standing OEM marking programs, holding approved layouts and delivering identical output across every production run.
        </p>
      </div>
    </section>;
}